// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__oV9eZ","col":"CardReaderDesc_col__T7mlT","label":"CardReaderDesc_label__3HoFM"};